/* eslint-disable react/no-unused-prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Grid from 'material-ui/Grid';
import WhiteButton from '../../../common/components/Buttons/WhiteButton';
import SectionTitle from '../../../common/components/Typography/SectionTitle';
import colors from '../../../../config/themeColors';

const types = [
    {
        type: 'purchase',
        label: 'Purchase',
    },
    {
        type: 'remortgage_current_balance',
        label: 'Remortgage Current Balance',
    },
    {
        type: 'remortgage_and_borrow_more',
        label: 'Remortgage And Borrow More',
    },
];
const styles = ({ spacing: { unit } }) => ({
    root: {
        padding: unit * 2,
        paddingTop: unit,
    },
    mortgageTypes: {
        display: 'flex',
    },
    mortgageType: {
        height: '270px',
        flexGrow: 1,
        borderRadius: '4px',
        backgroundColor: colors.white,
        boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.12)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        boxSizing: 'border-box',
    },
    mortgageTypeSelected: {
        border: `3px solid ${colors.bloodOrange}`,
    },
    mortgageTitle: {
        fontSize: '16px',
        color: colors.black,
    },
    selectHolder: {
        alignSelf: 'flex-end',
        padding: '16px',
        textAlign: 'center',
        width: 'calc(100% - 32px);',
        backgroundColor: colors.white3,
    },
    sectionTitleHolder: {
        padding: '10px',
        textAlign: 'center',
        width: 'calc(100% - 20px)',
    },
    sectionIcon: {
        marginTop: '8px',
        marginBottom: '8px',
        width: '80px',
        height: '80px',
        borderRadius: '50%',
        backgroundColor: colors.white4,
        textAlign: 'center',
        display: 'inline-block',
    },
    sectionTitle: {
        marginBottom: '16px',
    },
});

function MortgageType(props) {
    const setMortgageType = (type) => {
        props.setMortgageType(type);
        props.setStepsUncompleted(0);
        props.setStepCompleted(4, false);
    };
    return (props.applicationType === 'ltd' || props.applicants)
        ? (
            <div className={props.classes.root}>
                <div className={props.classes.sectionTitle}>
                    <SectionTitle>
                        Type of mortgage
                    </SectionTitle>
                </div>
                <Grid
                    container
                    spacing={16}
                    className={props.classes.gridContainer}
                >
                    {types.map(item => (
                        <Grid
                            item
                            xs={12}
                            sm={4}
                            key={item.type}
                        >
                            <div
                                className={[props.classes.mortgageType, props.mortgageType === item.type ? props.classes.mortgageTypeSelected : ''].join(' ')}
                            >
                                <div className={props.classes.sectionTitleHolder}>
                                    <div className={props.classes.sectionIcon}>
                                    </div>
                                    <Typography className={props.classes.mortgageTitle}>
                                        {item.label}
                                    </Typography>
                                </div>
                                <div className={props.classes.selectHolder}>
                                    <WhiteButton
                                        variant="raised"
                                        onClick={() => setMortgageType(item.type)}
                                        isSelected={props.mortgageType === item.type}
                                    />
                                </div>
                            </div>
                        </Grid>
                    ))}
                </Grid>
            </div>
        )
        : '';
}

MortgageType.propTypes = {
    classes: PropTypes.object.isRequired,
    applicationType: PropTypes.string.isRequired,
    applicants: PropTypes.number.isRequired,
    mortgageType: PropTypes.string.isRequired,
    setStepsUncompleted: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    setMortgageType: PropTypes.func.isRequired,
};

export default withStyles(styles)(MortgageType);



// WEBPACK FOOTER //
// ./src/app/FormStepper/QuickQuote/components/MortgageType.js